import semver from 'semver'

/**
 * Determine if a feature meets the minimum android SDK version.
 * @param {String} androidSDKVersion - the Android SDK Version from VNAndroidSDK - version state
 * @param {Strings} minimumVersion - The minimum android sdk sem version.
 * @returns {Boolean} - Returns ture if compatible, false otherwise (ignores pre-releases)
 */
export const isSDKCompatible = (androidSDKVersion, minimumVersion) => {
  return androidSDKVersion && semver.gte(androidSDKVersion, minimumVersion, { includePrerelease: true })
}

/**
 * Internal method. Parse a boolean URL parameter.
 * Make sure that this is used at the correct time. It has to be used when the parameter is set in
 * the URL, not any URL that the web application is redirected to. Device login is a good entry
 * point to use this method.
 * @param {String} paramName The name of the URL parameter to parse.
 * @returns The boolean value of the URL parameter.
 */
const parseBooleanUrlParam = (paramName, parseNullAsFalse = true) => {
  const urlParams = new URLSearchParams(window.location.search)
  const booleanParamValue = urlParams.get(paramName)

  if (booleanParamValue && booleanParamValue === 'true') return true
  return parseNullAsFalse ? false : booleanParamValue === 'false' ? false : booleanParamValue
}

export const isCFDMode = () => {
  return parseBooleanUrlParam('cfd')
}

export const isSummitMode = () => {
  return parseBooleanUrlParam('summit')
}

export const isRunningOnAndroid = () => {
  if (window.VN_DATA_BRIDGE !== undefined) return true

  return parseBooleanUrlParam('apk')
}

// eDCC means E700 in Roman numerals.
export const isE700Device = () => {
  return parseBooleanUrlParam('eDCC', false)
}
